export default __webpack_public_path__ + "static/media/gloves_of_the_whispering_blade.070da304.jpg";